import { create } from 'zustand';

// Removed SetupModalType definition

interface UIStore {
  isMenuOpen: boolean;
  toggleMenu: () => void;
  setMenuOpen: (isOpen: boolean) => void;

  /** Controls visibility of the dashboard checklist modal */
  showChecklistModal: boolean;
  setShowChecklistModal: (show: boolean) => void;
}

export const useUIStore = create<UIStore>((set) => ({
  // Start with false to avoid SSR hydration mismatch
  // Will be updated by useEffect in components based on screen size
  isMenuOpen: false,
  toggleMenu: () => set((state) => ({ isMenuOpen: !state.isMenuOpen })),
  setMenuOpen: (isOpen) => set({ isMenuOpen: isOpen }),

  showChecklistModal: false,
  setShowChecklistModal: (show) => set({ showChecklistModal: show }),
}));
